(function () {
  var form = document.getElementById('syp-quote-form');
  if (!form || form.dataset.enquiryReady) return;
  form.dataset.enquiryReady = 'true';
  var section = form.closest('.section-syp-quote');
  var quote = section.querySelector('.syp-quote');
  var anchor = quote.id;
  var product = form.querySelector('#syp-product');
  var message = form.querySelector('#syp-message');
  var projectPlaceholder = message.placeholder;
  var params = new URLSearchParams(window.location.search);
  var handle = params.get('product');
  var posted = form.querySelector('[data-syp-posted]');
  var pendingKey = 'tbl-product-enquiry';
  if (!handle && posted) {
    try {
      var pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (pending && Date.now() - pending.time < 3600000) {
        handle = pending.handle;
        params.set('enquiry', pending.mode);
      }
      sessionStorage.removeItem(pendingKey);
    } catch (error) {}
  }
  var productTitle = handle ? handle.replace(/-/g, ' ') : '';
  var root = form.querySelector('[data-product-root]').dataset.productRoot || '/';
  var productPath = handle ? root + 'products/' + encodeURIComponent(handle) : '';
  var productMode = false;
  var planning = form.querySelector('.syp-project__planning');

  function chooseHelp(key) {
    if (!key) return;
    var input = Array.from(form.querySelectorAll('[data-help-key]')).find(function (item) { return item.dataset.helpKey === key; });
    if (input) input.checked = true;
    if (key === 'design' && planning) planning.open = true;
  }

  function route(mode) {
    var url = new URL(window.location.href);
    url.searchParams.set('product', handle);
    if (mode === 'project') url.searchParams.set('enquiry', 'project');
    else url.searchParams.delete('enquiry');
    url.hash = anchor;
    return url;
  }

  function setMode(simple) {
    productMode = Boolean(simple && handle);
    document.documentElement.classList.toggle('syp-product-enquiry', productMode);
    section.querySelectorAll('[data-project-only]').forEach(function (element) {
      element.hidden = productMode;
      element.querySelectorAll('input, select, textarea').forEach(function (input) { input.disabled = productMode; });
    });
    section.querySelectorAll('[data-enquiry-only]').forEach(function (element) { element.hidden = !productMode; });
    form.querySelectorAll('[data-enquiry-url], [data-enquiry-reference]').forEach(function (input) { input.disabled = !handle; });
    form.querySelector('[data-enquiry-help]').disabled = !productMode;
    product.disabled = false;
    message.placeholder = productMode ? message.dataset.enquiryPlaceholder : projectPlaceholder;
    message.rows = 4;
    if (productMode) chooseHelp('products');
    var returnLink = section.querySelector('[data-enquiry-return]');
    returnLink.hidden = !handle || productMode;
    if (handle) {
      section.querySelector('[data-enquiry-project]').href = route('project').href;
      returnLink.href = route('product').href;
    }
  }

  chooseHelp(params.get('help'));
  if (handle) {
    if (!product.value) product.value = productTitle;
    form.querySelector('[data-enquiry-url]').value = new URL(productPath, window.location.origin).href;
    form.querySelector('[data-enquiry-reference]').value = handle;
    var title = section.querySelector('[data-enquiry-title]');
    title.textContent = productTitle;
    var back = section.querySelector('[data-enquiry-back]');
    back.href = productPath;
    back.hidden = false;
    setMode(params.get('enquiry') !== 'project');
    fetch(productPath + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.title) throw new Error('Product unavailable');
        productTitle = data.title;
        title.textContent = productTitle;
        product.value = productTitle;
        form.querySelector('[data-enquiry-reference]').value = handle;
        var vendor = section.querySelector('[data-enquiry-vendor]');
        vendor.textContent = data.vendor || '';
        vendor.hidden = !data.vendor;
        var source = data.featured_image || (data.images && data.images[0]);
        if (source) {
          var image = section.querySelector('[data-enquiry-image]');
          var imageUrl = new URL(source, window.location.origin);
          if (imageUrl.protocol !== 'https:') return;
          imageUrl.searchParams.set('width', '800');
          image.alt = productTitle;
          image.addEventListener('load', function () { image.parentElement.hidden = false; });
          image.src = imageUrl.href;
        }
      })
      .catch(function () {
        section.querySelector('[data-enquiry-fallback]').hidden = false;
        back.hidden = true;
      });
  } else {
    setMode(false);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    if (link.matches('[data-enquiry-project], [data-enquiry-return]')) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      var simple = link.matches('[data-enquiry-return]');
      history.pushState({}, '', route(simple ? 'product' : 'project'));
      setMode(simple);
      quote.scrollIntoView({ block: 'start' });
      var heading = section.querySelector(simple ? '.syp-enquiry__head h1' : '.syp__head h2');
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
      return;
    }
    var href = link.getAttribute('href') || '';
    if (href.indexOf('#' + anchor) === -1) return;
    chooseHelp(link.getAttribute('data-syp-help'));
    var set = link.closest('[data-set-name]');
    if (set && product && !product.value) {
      var titles = Array.from(set.querySelectorAll('.bly-set__item-title a')).map(function (item) { return item.textContent.trim(); });
      product.value = set.getAttribute('data-set-name') + (titles.length ? ' (' + titles.join(', ') + ')' : '');
      chooseHelp('products');
    }
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('syp-quote-in-view', entries[0].isIntersecting);
    }).observe(form);
  }

  form.addEventListener('change', function (event) {
    if (planning && event.target.matches('[data-help-key="design"]') && event.target.checked) planning.open = true;
  });

  window.addEventListener('popstate', function () {
    if (handle) setMode(new URLSearchParams(window.location.search).get('enquiry') !== 'project');
  });
  form.addEventListener('submit', function () {
    if (!handle) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ handle: handle, mode: productMode ? 'product' : 'project', time: Date.now() })); } catch (error) {}
  });
  if (posted) {
    posted.scrollIntoView({ block: 'center' });
    posted.focus({ preventScroll: true });
  }
})();
